import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { stringify } from 'qs';
import keys from 'lodash/keys';
import * as TYPES from './types';
import { extractProductReference } from '~/helpers/extract-helper';
import { fetchProductNav, fetchProduct as _fetchProduct, fetchProductCarousels as _fetchProductCarousels } from '~/services/product';
export default {
  fetchProductCarousels: function () {
    var _fetchProductCarousels2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref, _ref2) {
      var commit, alias, profileId, exclude, reference, product;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              alias = _ref2.alias, profileId = _ref2.profileId, exclude = _ref2.exclude;
              reference = extractProductReference(alias);
              _context.next = 5;
              return _fetchProductCarousels(this, reference, profileId, exclude);

            case 5:
              product = _context.sent;
              commit(TYPES.SET_PRODUCT_CAROUSELS, product);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchProductCarousels(_x, _x2) {
      return _fetchProductCarousels2.apply(this, arguments);
    }

    return fetchProductCarousels;
  }(),
  fetchProduct: function () {
    var _fetchProduct2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref3, _ref4) {
      var commit, alias, query, profileId, reference, _ref5, _ref6, productNav, product, currentLocale, currentQuery, currentAlias;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit;
              alias = _ref4.alias, query = _ref4.query, profileId = _ref4.profileId;
              reference = extractProductReference(alias);
              _context2.next = 5;
              return Promise.all([fetchProductNav(this, reference), _fetchProduct(this, reference, profileId)]);

            case 5:
              _ref5 = _context2.sent;
              _ref6 = _slicedToArray(_ref5, 2);
              productNav = _ref6[0];
              product = _ref6[1];
              currentLocale = this.state.i18n.currentLocale;
              currentQuery = keys(query).length ? "?".concat(stringify(query)) : '';
              currentAlias = "".concat(productNav.product.slug, "-").concat(productNav.product.reference, ".htm");

              if (alias !== currentAlias && process.server) {
                this.app.context.redirect(301, "/".concat(currentLocale.market, "/").concat(currentLocale.language, "/p/").concat(currentAlias).concat(currentQuery));
              }

              if (productNav.product && productNav.product.redirect_url) {
                if (process.server && productNav.product.redirect_url) {
                  this.app.context.redirect(301, "".concat(productNav.product.redirect_url).concat(currentQuery));
                } else {
                  window.location.href = "".concat(productNav.product.redirect_url).concat(currentQuery);
                }
              }

              commit(TYPES.SET_PRODUCT_NAV, productNav);
              commit(TYPES.SET_PRODUCT, product);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function fetchProduct(_x3, _x4) {
      return _fetchProduct2.apply(this, arguments);
    }

    return fetchProduct;
  }()
};